import React, { useState, useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";
import { db } from "../../Firebase.js";
import PageNotFound from "../../PageNotFound.js";

export default function DocumentRedirect(props) {
  const { id } = useParams();

  const [projectId, setProjectId] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    db.collection("documents").doc(id).get().then(result => {

      if (!result.exists) {
        setNotFound(true);
      } else {
        const projectId = result.get("projectId");

        if (projectId) {
          setProjectId(result.get("projectId"));
        } else {
          setNotFound(true);
        }
      }
    });
  }, []);

  if (notFound) {
    return (
      <PageNotFound
        disableHeader={true}
        message="This page does not exist."
      />
    );
  }

  if (!projectId) {
    return null;
  }

  if (projectId) {
    return <Redirect to={`/app/project/${projectId}/#doc=${id}`} />;
  }

  return null;


}
